import { render } from "./SelectProject.vue?vue&type=template&id=664616ac&scoped=true"
import script from "./SelectProject.vue?vue&type=script&lang=js"
export * from "./SelectProject.vue?vue&type=script&lang=js"

import "./SelectProject.vue?vue&type=style&index=0&id=664616ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664616ac"]])

export default __exports__